module.exports = __webpack_public_path__ + "img/banner_deco.1900d618.svg";